import { RootState } from "../rootReducer";
import { createSelector } from "@reduxjs/toolkit";

export const appSettingStatus = createSelector(
    [(state: RootState) => state.appSettings.isLoading],
    isLoading => isLoading
)

export const appSettingsFailureState = createSelector(
    [(state: RootState) => state.appSettings.appSettingsFailure],
    appSettingsFailure => appSettingsFailure
)

export const appSettingsSuccessState = createSelector(
    [(state: RootState) => state.appSettings.appSettingsSuccess],
    appSettingsSuccess => appSettingsSuccess
)

export const appSpecializations = createSelector(
    [(state: RootState) => state.appSettings.specialization],
    specialization => specialization.filter(item => item.status && !item.hospital_only)
)

export const allAppSpecializations = createSelector(
    [(state: RootState) => state.appSettings.specialization],
    specialization => specialization
)

export const appSpecialistList = createSelector(
    [(state: RootState) => state.appSettings.specialistList],
    (specialistList: any) => specialistList
)

export const appCountries = createSelector(
    [(state: RootState) => state.appSettings.countries],
    countries => countries
)

export const appAdminRoles = createSelector(
    [(state: RootState) => state.appSettings.adminRoles],
    adminRoles => adminRoles
)

export const dashboardSearchTerm = createSelector(
    [(state: RootState) => state.appSettings.dashboardSearchTerm],
    dashboardSearchTerm => dashboardSearchTerm
)

export const specialistFilterOptions = createSelector(
    [(state: RootState) => state.appSettings.filterManagement],
    filterManagement => filterManagement
)